// Bull Run (sprint 35 item 2): hold and slide to lean against the bucks; the head drop and snort show TELL steps before each one.
// Shared by the page and the server replay. Integer fixed-point only (lean in thousandths, velocity in thousandths a second,
// dt = 1/15 s): no Math.pow/sin/exp, no floats. All randomness is read from the seed bytes (one per step), never from a clock.
export const id = 'bull';
export const STEPS = 120;
export const NAME = 'Bull Run';

// The two tuning numbers (the designer's), both integers:
//  kick/pull: a buck adds kick (thousandths a second) to the velocity; one full push (input 4) adds pull (thousandths a second squared)
//             to the acceleration. The late bucks kick 23/18 of `kick`, the big rear 14/9 of it.
//  tell:      steps between the head drop and the buck (5 is 0.333 s, the nearest step to the owner's 0.35 s).
export const TUNING = { kick: 1550, pull: 7150, tell: 5 };
const TIP = 2600, DAMP = 2200; // the lean tips over by itself (2.6) and the bull's own motion is damped (2.2); fixed, not tuned

const CLEAN = 700; // a clean ride never leans past 0.7 of the way to a throw (a 0.30 s rider manages it about 4 rides in 10)
const BUCKS = [15, 29, 43, 57, 71, 81, 91, 101]; // 0-14 stands (one teaching snort at 5, no buck), then every 14 steps, then every 10
const BIG = 107;
const REPEAT_BELOW = 72; // after step 60 a seed byte under 72 (28 %) repeats the last side

export function init(seed, { mode = 'bonus' } = {}) {
  const { kick, tell } = TUNING;
  const harder = mode === 'rescue' ? 115 : 100; // the rescue ride kicks about 15 % harder
  const events = [];
  let last = seed[0] & 1 ? 1 : -1;
  BUCKS.forEach((buckStep, i) => {
    const side = i === 0 ? last : buckStep > 60 && seed[buckStep] < REPEAT_BELOW ? last : -last;
    last = side;
    const k = buckStep > 60 ? Math.trunc((kick * 23) / 18) : kick;
    events.push({ tellStep: buckStep - tell, buckStep, side, sideShown: true, kick: Math.trunc((k * harder) / 100) });
  });
  events.push({ tellStep: BIG - tell, buckStep: BIG, side: seed[BIG] & 1 ? 1 : -1, sideShown: false, kick: Math.trunc((Math.trunc((kick * 14) / 9) * harder) / 100) });
  return { t: 0, lean: 0, vel: 0, events, over: false, thrown: false, clean: true };
}

// What a player could see (the frozen players and the page both read exactly this). The big rear's side is not shown.
export function observe(s) {
  return { t: s.t, lean: s.lean, vel: s.vel, events: s.events.map(({ tellStep, buckStep, side, sideShown }) => ({ tellStep, buckStep, side, sideShown })) };
}

export function step(s, input) {
  if (s.over) return s;
  const q = Math.max(-4, Math.min(4, Math.trunc(Number(input)) || 0));
  const e = s.events.find(b => b.buckStep === s.t);
  if (e) s.vel += e.side * e.kick;
  const acc = Math.trunc((TIP * s.lean) / 1000) + Math.trunc((TUNING.pull * q) / 4) - Math.trunc((DAMP * s.vel) / 1000);
  s.vel += Math.trunc(acc / 15);
  s.lean += Math.trunc(s.vel / 15);
  s.t += 1;
  if (Math.abs(s.lean) > CLEAN) s.clean = false;
  if (Math.abs(s.lean) >= 1000) { s.thrown = true; s.over = true; } else if (s.t >= STEPS) s.over = true;
  return s;
}

export const result = s => ({ over: s.over, steps: s.t, reachedEnd: s.over && !s.thrown, clean: s.clean });
